import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {ButtonComponent} from '../../../../elements/button/button.component';
import {TextsComponent} from "../../../../elements/texts/texts.component";
import {CountryService} from '../../../../../services/country-service';
import {environment} from '../../../../../environments/environment';
import {Router} from '@angular/router';
import {Location} from '@angular/common';
import {IconComponent} from '../../../../elements/icon/icon.component';
import {Icons} from '../../../../../model/icon';

@Component({
  selector: 'app-main-visit',
  imports: [
    TextsComponent,
    ButtonComponent,
    IconComponent
  ],
  templateUrl: './main-visit.component.html',
  standalone: true,
  styleUrl: './main-visit.component.scss'
})
export class MainVisitComponent implements OnInit {
  constructor(
    protected countryService: CountryService,
    protected router: Router,
    public location: Location) {
  }

  @Output() mainLoading = new EventEmitter<boolean>();

  bg: string = '/app/assets/images/palace.jpeg';

  ngOnInit() {
    this.mainLoading.emit(false);
  }


  getBackground(type: string) {
    const country = this.countryService.getRandom();
    switch (type) {
      case 'bg': {
        const path = country.additionalImage ?
          (environment.s3Prefix + country.additionalImage) :
          '/app/assets/images/palace.jpeg';
        const x = 'linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), url("';
        return x + path + '")';
      }
      case 'filter': {
        return country.cssStyleAdditionalImage ?? '';
      }
      default:
        return ''
    }
  }

  openCountry() {
    const country = this.countryService.getRandom();
    const countryUrl = country.url;
    let continentUrl = country.continent?.url;
    if (continentUrl === undefined) {
      return;
    }
    this.router.navigate([`/destinations/${continentUrl}/${countryUrl}`]).then(r => r);
  }

  protected readonly Icons = Icons;
}
